module.exports = __webpack_public_path__ + "static/media/age.16b1194d.svg";